import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  clearSuccessMessage,
  Context,
  bulkRegisterTeachers,
  teachersPath,
  BULK_REGISTER_TEACHERS_SUCCESS_MESSAGE,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import TeacherSpreadSheet from "../../../templates/manager/TeacherSpreadSheet";
import { ITeacherForRegister } from "../../../state";
import useWaitApiCall from "../../../hooks/useWaitApiCall";

const BulkRegisterTeachers = () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();

  React.useEffect(() => {
    if (state.success_message === BULK_REGISTER_TEACHERS_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(teachersPath);
    }
  }, [history, dispatch, state.success_message]);

  const bulkRegisterTeachersFunc = React.useCallback(
    (teachers: ITeacherForRegister[]) => {
      dispatch(peep(bulkRegisterTeachers(teachers)));
    },
    [dispatch, peep],
  );

  return (
    <div>
      <Breadcrumb
        links={[{ title: titles.teachers, to: teachersPath }]}
        currentTitle={titles.bulkRegisterTeachers}
      />
      <TeacherSpreadSheet
        title={titles.bulkRegisterTeachers}
        calling={calling}
        error={state.error}
        teachers={state.teachers}
        save={bulkRegisterTeachersFunc}
      />
    </div>
  );
};

export default BulkRegisterTeachers;
